import React, { useEffect, useState, } from 'react'
import { Link, useHistory, useParams, } from 'react-router-dom'
import HtmlParser from 'react-html-parser';
import moment from 'moment';

import $ from 'jquery';
import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';
import Menu from '../main/Menu'

import {
    dataTableLanguaje, responseGet, globalSettings, styles, dateTimeFormatGlobalSet, buttonProcessGet, separatorsNumbersSet, sendMessageCloseCurrentWindowAsync,
    numberSet, languageObjGet, isUndNullEmp, LoadingSection, awaitDelay
} from '../../helpers/settings'
import { purchaseStatusGet } from '../../controllers/purchases/purchases';
import BuildingHeader from '../buildings/BuildingHeader';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { purchaseModelGet } from '../../models/expenses/purchase';

const currentMethod = 'SupplierCurrentBalance';

export default function SupplierCurrentBalance({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const { id, } = useParams();
    const history = useHistory();
    const auth = useAuth();
    //const userRole = checkIfUserIsMaster({email: auth?.user?.email || '', languageId: '', subMethod: '', })?.result;
    const [showLoading, setShowLoading] = useState({ building: true, supplier: true, purchases: true, });
    const descriptionPercentageObj = {
        success: 'description-percentage text-success',
        primary: 'description-percentage text-primary',
        danger: 'description-percentage text-danger',
    };
    //#endregion variables

    //#region purchases
    const dtPurchasesId = 'dtPurchases';
    const purchasesFromId = 'purchasesFrom';
    const purchasesToId = 'purchasesTo';
    const [purchasesFromError, setPurchasesFromError] = useState('');
    const [puchasesToError, setPurchasesToError] = useState('');

    const [purchasesBeforeBalance, setPurchasesBeforeBalance] = useState(numberSet('', 'd').result);
    const [purchasesPeriodBalance, setPurchasesPeriodBalance] = useState(numberSet('', 'd').result);
    const [purchasesCurrentBalance, setPurchasesCurrentBalance] = useState(numberSet('', 'd').result);
    const [purchases, setPurchases] = useState({});
    //#endregion purchases

    //#region supplier
    const [supplier, setSupplier] = useState({});
    const [supplierPurchaseData] = useState({});
    //#endregion supplier

    //#region building
    const [building, setBuilding] = useState({});
    //#endregion building

    //#region others
    const controls = {
        buttons: {
            // save: {
            //     id: 'btnCreate',
            //     className: 'btn btn-outline-warning mx-1',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            purchases: {
                buttons: {
                    find: {
                        className: 'btn btn-outline-info mx-1',
                        id: 'btnDtPurchasesFind',
                    },
                    print: {
                        className: 'btn btn-outline-secondary',
                        id: 'btnDtPurchasesPrint',
                    },
                    back: {
                        className: 'btn btn-outline-success mx-1',
                        id: 'btnDtPurchasesBack',
                    },
                },
                icons: {
                    find: {
                        id: 'iconDtPurchasesFind',
                        className: globalSettings?.icons?.search,
                    },
                    print: {
                        id: 'iconDtPurchasesPrint',
                        className: globalSettings?.icons?.print,
                    },
                    back: {
                        id: 'iconDtPurchasesBack',
                        className: globalSettings?.icons?.arrowCircleLeft,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtPurchasesId}_filter input`,
                        className: '',
                    },
                    from: {
                        id: `inputDtPurchasesFrom`,
                        className: 'form-control text-black bg-transparent datetimepicker-input',
                    },
                    to: {
                        id: `inputDtPurchasesTo`,
                        className: 'form-control text-black bg-transparent datetimepicker-input',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtPurchasesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    find: {
                        id: 'spDtPurchasesFind',
                        className: '',
                    },
                    print: {
                        id: 'spDtPurchasesPrint',
                        className: '',
                    },
                    back: {
                        id: 'spDtPurchasesBack',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // save: {
            //     id: 'icoSave',
            //     className: globalSettings?.icons?.save,
            // },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
        },
        spinners: {
            // save: {
            //     id: 'spSave',
            //     className: '',
            // },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region purchases (methods)
    const supplierPurchasesGetAsync = async ({ e = undefined, subMethod = '', }) => {
        const currentMethod = 'supplierPurchasesGetAsync';
        let response = responseGet();
        let processType = 0;
        try {
            //#region variables
            //#region old code
            //let purchasesObj?.purchases;
            //let purchasesObj?.beforeBalance = 0.00;
            //let purchasesObj?.periodBalance = 0.00;
            //let purchasesObj?.currentBalance = 0.00;
            //let purchasesObj?.movementAmount = 0.00;
            //#endregion old code
            const purchasesObj = {
                beforeBalance: 0.00,
                periodBalance: 0.00,
                currentBalance: 0.00,
                movementAmount: 0.00,
                purchases: [],
            };
            //#endregion variables

            $(`#${dtPurchasesId}`)?.DataTable()?.rows()?.clear()?.draw(true);

            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
                processType = 1;
            }

            if (processType === 0) {
                setShowLoading({ building: true, supplier: true, purchases: true, });
            } else if (processType === 1) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            }

            //#region form data validate
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                response = await formDataValidateAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    if (processType === 0) {
                        setShowLoading({ building: false, supplier: false, purchases: false, });
                    } else if (processType === 1) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    }
                    return response;
                }
            }
            //#endregion form data validate

            //#region total movements set
            response = await totalsMovementsSetAsync({
                purchasesBeforeBalance: numberSet({
                    number: 0.00,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                purchasesPeriodBalance: numberSet({
                    number: 0.00,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                purchasesCurrentBalance: numberSet({
                    number: 0.00,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                noDefinedValue: numberSet({
                    number: 0.00,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                if (processType === 0) {
                    setShowLoading({ building: false, supplier: false, purchases: false, });
                } else if (processType === 1) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                }
                return response;
            }
            //#endregion total movements set

            //#region movement data set
            response = await purchasesDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                if (processType === 0) {
                    setShowLoading({ building: false, supplier: false, purchases: false, });
                } else if (processType === 1) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                }
                return response;
            }
            //#endregion movement data set

            //#region purchases get
            supplierPurchaseData.conditionals = [];
            supplierPurchaseData.ordersBy = [
                { field: globalSettings?.collections?.properties?.number, value: 'desc', },
            ];
            dataObj = supplierPurchaseData;
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj.url = `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/`;
            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                if (processType === 0) {
                    setShowLoading({ building: false, supplier: false, purchases: false, });
                } else if (processType === 1) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                }
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            purchasesObj.purchases = response.result;
            supplierPurchaseData.building = purchasesObj?.purchases.building;
            supplierPurchaseData.supplier = purchasesObj?.purchases.supplier;
            supplierPurchaseData.user = purchasesObj?.purchases.user;
            supplierPurchaseData.purchases = purchasesObj?.purchases.purchases;

            setPurchases(supplierPurchaseData);
            setBuilding(purchasesObj?.purchases?.building);
            setSupplier(purchasesObj?.purchases?.supplier);

            purchasesObj.beforeBalance = purchasesObj?.purchases.purchases.resume.beforeBalance;
            purchasesObj.periodBalance = purchasesObj?.purchases.purchases.resume.periodBalance;
            purchasesObj.currentBalance = purchasesObj?.purchases.purchases.resume.currentBalance;
            purchasesObj.movementAmount = 0.00;
            //#endregion purchases get

            //#region dataTable set
            //#region old code
            // response = dataTablesSetAsync();
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading({ building: false, supplier: false, purchases: false, });
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, true, response.urlGoTo, auth, false);
            //     return response;
            // }
            //#endregion old code
            //#endregion dataTable set

            //#region dateTime in control sets
            response = await dateInControlSetAsync({
                movementFrom: supplierPurchaseData?.movementFrom,
                movementTo: supplierPurchaseData?.movementTo,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                if (processType === 0) {
                    setShowLoading({ building: false, supplier: false, purchases: false, });
                } else if (processType === 1) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                }
                return response;
            }
            //#endregion dateTime in control sets

            //#region data load in dataTable
            response = await loadDataInDataTableSync({
                data: purchasesObj?.purchases,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                if (processType === 0) {
                    setShowLoading({ building: false, supplier: false, purchases: false, });
                } else if (processType === 1) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                }
                return response;
            }
            //#endregion data load in dataTable

            //#region load total movements
            response = await totalsMovementsSetAsync({
                purchasesBeforeBalance: purchasesObj?.beforeBalance,
                purchasesPeriodBalance: purchasesObj?.periodBalance,
                purchasesCurrentBalance: purchasesObj?.currentBalance,
                noDefinedValue: purchasesObj?.movementAmount,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                if (processType === 0) {
                    setShowLoading({ building: false, supplier: false, purchases: false, });
                } else if (processType === 1) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                }
                return response;
            }
            //#endregion load total movements

            if (processType === 0) {
                setShowLoading({ building: false, supplier: false, purchases: false, });
            } else if (processType === 1) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }
        } catch (ex) {
            if (processType === 0) {
                setShowLoading({ building: false, supplier: false, purchases: false, });
            } else if (processType === 1) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const purchasesDataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'purchasesDataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            // const localDateFormat = globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo;
            // let localMovementsFrom = $(`#${purchasesFromId}`)?.datetimepicker('date')?._d;
            // localMovementsFrom = dateTimeFormatGlobalSet(localMovementsFrom, localDateFormat).result;

            // let localMovementsTo = $(`#${purchasesToId}`)?.datetimepicker('date')?._d;
            // localMovementsTo = dateTimeFormatGlobalSet(localMovementsTo, localDateFormat).result;
            //#endregion old code

            const dateTimeObj = {
                format: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                from: '',
                fromDate: $(`#${purchasesFromId}`)?.datetimepicker('date')?._d,
                to: '',
                toDate: $(`#${purchasesToId}`)?.datetimepicker('date')?._d,
            };
            dateTimeObj.from = dateTimeFormatGlobalSet({
                date: dateTimeObj?.fromDate,
                type: dateTimeObj?.format,
                format: 0,
                addTime: false,
                secondsShow: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            dateTimeObj.to = dateTimeFormatGlobalSet({
                date: dateTimeObj?.toDate,
                type: dateTimeObj?.format,
                format: 0,
                addTime: false,
                secondsShow: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            //#endregion variables

            //#region methods
            supplierPurchaseData.supplierId = id;
            //supplierPurchaseData.dateFrom = localMovementsFrom;
            supplierPurchaseData.dateFrom = dateTimeObj?.from;
            //supplierPurchaseData.dateTo = localMovementsTo;
            supplierPurchaseData.dateTo = dateTimeObj?.to;
            supplierPurchaseData.conditionals = [];
            supplierPurchaseData.isResumen = false;
            supplierPurchaseData.isDetail = true;
            supplierPurchaseData.method = globalSettings?.app?.backend?.methods?.supplierBalance;
            supplierPurchaseData.ordersBy = [];
            supplierPurchaseData.processType = globalSettings?.app?.reports.processType.supplierCurrentBalanceGet;
            supplierPurchaseData.userId = auth?.user?.uid;

            supplierPurchaseData.type = response.result;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const purchasesPrintAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'purchasesPrintAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            //#region variables
            let purchasesReportLocal = {};
            let dtFilter = $(`#${dtPurchasesId}`)?.DataTable()?.search();
            //#endregion variables

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });

            //#region add data to report
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            purchases.filter = dtFilter;
            purchases.buildingId = building?.id;

            dataObj = {
                ...purchases,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlReports}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            purchasesReportLocal = response?.result;

            window?.open(`/${globalSettings?.app?.reports?.supplierCurrentBalancePrint}/${purchasesReportLocal?.id}`, '_blank');
            //#endregion add data to report

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const purchaseEditDetailDeleteGetAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'purchaseEditDetailDeleteGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let purchaseLocal = purchaseModelGet({});
            //#endregion variables

            setShowLoading({ building: false, supplier: false, purchases: true, });

            //#region purchase get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    showAlert: true,
                    languageId: languageObj?.id,
                },
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchases}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, supplier: false, purchases: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            purchaseLocal = response?.result?.purchase || {};
            //#endregion purchase get

            //#region methods
            switch (processType) {
                case 2:
                    window?.open(`${globalSettings?.app?.backend?.urlPurchaseDetail}/${purchaseLocal.id}`, '_blank');
                    setShowLoading({ building: false, supplier: false, purchases: false, });
                    break;
                default:
                    break;
            }
            //#endregion methods
        } catch (ex) {
            setShowLoading({ building: false, supplier: false, purchases: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion purchases (methods)

    //#region others (methods)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, supplier: true, purchases: true, });

            //#region dataTable set
            response = await dataTablesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, supplier: false, purchases: false, });
                return;
            }
            //#endregion dataTable set

            //#region dateTime in control sets
            response = await dateInControlSetAsync({
                movementFrom: supplierPurchaseData?.movementFrom,
                movementTo: supplierPurchaseData?.movementTo,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, supplier: false, purchases: false, });
                return;
            }
            //#endregion dateTime in control sets

            //#region data get
            response = await supplierPurchasesGetAsync({
                e: null,
                processType: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, supplier: false, purchases: false, });
                return;
            }
            //#endregion data get

            setShowLoading({ building: false, supplier: false, purchases: false, });
        } catch (ex) {
            setShowLoading({ building: false, supplier: false, purchases: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //const dateTimeObj?.from = $(`#${controls?.dataTables?.purchases?.inputs?.from?.id}`)?.val();
            //const dateTimeObj?.to = $(`#${controls?.dataTables?.purchases?.inputs?.to?.id}`)?.val();
            //#endregion old code
            const dateTimeObj = {
                from: $(`#${controls?.dataTables?.purchases?.inputs?.from?.id}`)?.val(),
                to: $(`#${controls?.dataTables?.purchases?.inputs?.to?.id}`)?.val(),
                //startDtp: $(`#${startDateId}`)?.datetimepicker('date')?._d,
                //endDtp: $(`#${endDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: dateTimeObj?.from, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: supplierPurchaseData?.dateFrom, subMethod: currentMethod, })?.result) {
                setPurchasesFromError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dateTimeObj?.to, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: supplierPurchaseData?.dateTo, subMethod: currentMethod, })?.result) {
                setPurchasesToError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dateInControlSetAsync = async ({ movementFrom = undefined, movementTo = undefined, subMethod = '', }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.from = '';
            //let dateTimeObj?.to = '';
            //const dateTimeObj?.format = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
            //const dateTimeObj?.formatTwo = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.momentStartMonth = moment().startOf('month')._d;
            //const dateTimeObj?.momentEndMonth = moment().endOf('month')._d;
            //#endregion old code
            const dateTimeObj = {
                from: '',
                to: '',
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
                time: 0,
                momentStartMonth: moment().startOf('month')._d,
                momentEndMonth: moment().endOf('month')._d,
            };
            //#endregion variables

            //#region initialize
            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: globalSettings?.react?.tempusDominus?.icons,
                buttons: globalSettings?.react?.tempusDominus?.buttons,
                tooltips: globalSettings?.react?.tempusDominus?.tooltips,
                locale: languageObj?.id,
            });
            //#endregion initialize

            //#region from data set
            if (!isUndNullEmp({ data: movementFrom, subMethod: currentMethod, })?.result) {
                dateTimeObj.from = dateTimeFormatGlobalSet({
                    date: movementFrom,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.from = dateTimeFormatGlobalSet({
                    date: dateTimeObj?.momentStartMonth,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $(`#${purchasesFromId}`)?.datetimepicker({
                date: moment(`${dateTimeObj?.from}`, dateTimeObj?.formatTwo),
                default: false,
                timepicker: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion from data set

            //#region data set
            if (!isUndNullEmp({ data: movementTo, subMethod: currentMethod, })?.result) {
                dateTimeObj.to = dateTimeFormatGlobalSet({
                    date: movementTo,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.to = dateTimeFormatGlobalSet({
                    date: dateTimeObj?.momentEndMonth,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $(`#${purchasesToId}`)?.datetimepicker({
                date: moment(`${dateTimeObj?.to}`, dateTimeObj?.formatTwo),
                default: false,
                timepicker: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion data set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const goToBackAsync = async ({ e = {}, subMethod = '', }) => {
        let response = responseGet();
        try {
            e?.preventDefault();

            controlsStatusSet({ processType: 3, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            history.push(globalSettings?.app?.backend?.urlSuppliers);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablePurchasesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablePurchasesSetAsync';
        let response = responseGet();
        try {
            $(`#${dtPurchasesId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { className: 'text-right', title: globalSettings?.labels?.number?.[languageObj?.id], width: '10%', },
                    { title: globalSettings?.labels?.date?.[languageObj?.id], width: '10%', },
                    { title: globalSettings?.labels?.purchase?.[languageObj?.id], width: '15%', },
                    { title: globalSettings?.labels?.control?.[languageObj?.id], width: '15%', },
                    { title: globalSettings?.labels?.status?.[languageObj?.id], width: '15%', },
                    { className: 'text-right', title: globalSettings?.labels?.balance?.[languageObj?.id], width: '15%', },
                    { className: 'text-right', title: globalSettings?.labels?.neto?.[languageObj?.id], width: '15%', },
                    { className: 'text-center', title: globalSettings?.labels?.process?.[languageObj?.id], orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //ordering: false,
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                searching: false,
                //}).buttons().container().appendTo(`#${dtPurchasesId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            response = await dataTablePurchasesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const loadDataInDataTableSync = async ({ data = {}, subMethod = '' }) => {
        const currentMethod = 'loadDataInDataTableSync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            //#endregion variables

            //#region old code
            // //#region Before
            // if (!isUndefined(data) &&
            //     !isUndefined(data.purchases) && !isNull(data.purchases) &&
            //     !isUndefined(data.purchases.before) && !isNull(data.purchases.before) && data.purchases.before.length > 0) {
            //     map(data.purchases.before, (detail) => {
            //         localDataRows.push([
            //             detail.number,
            //             dateTimeFormatGlobalSet(detail.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, false).result,
            //             detail.invoiceNumber,
            //             detail.invoiceControlNumber,
            //             localPurchaseStatusGet(detail, false, false).result,
            //             separatorsNumbersSet(detail.balance).result,
            //             separatorsNumbersSet(detail.total).result,
            //             buttonProcessGet(
            //                 detail.id,
            //                 detail.number,
            //                 true,
            //                 globalSettings?.labels?.view?.[languageObj?.id],
            //                 true,
            //                 false,
            //                 '',
            //                 false,
            //                 false,
            //                 '',
            //                 false,
            //                 []
            //             ).result,
            //         ]);
            //     });
            // }
            // //#endregion Before
            //#endregion old code

            //#region Period
            if (!isUndNullEmp({ data: data?.purchases?.period, subMethod: currentMethod, })?.result && data?.purchases?.period?.length > 0) {
                data?.purchases?.period?.forEach((detail) => {
                    dtRows.push([
                        detail?.number,
                        dateTimeFormatGlobalSet({
                            date: detail?.date,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        detail?.invoiceNumber,
                        detail?.invoiceControlNumber,
                        purchaseStatusGet({
                            purchase: detail,
                            showStateLabel: false,
                            htmlParser: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        //separatorsNumbersSet(detail?.balance).result,
                        separatorsNumbersSet({
                            number: detail?.balance,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        //separatorsNumbersSet(detail?.total).result,
                        separatorsNumbersSet({
                            number: detail?.total,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.number,
                            showDetails: true,
                            labelDetails: globalSettings?.labels?.view?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: false,
                            labelEdit: '',
                            enabledEdit: false,
                            showDelete: false,
                            labelDelete: '',
                            enabledDelete: false,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                });
            }
            //#endregion Period

            //#region data in dataTable set
            $(`#${dtPurchasesId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion data in dataTable set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    //#region old cod
    // const localDataTablesClear = (clearDtMovements = false) => {
    //     let response = responseGet();
    //     try {
    //         if (clearDtMovements) {
    //             $(`#${dtPurchasesId}`)?.DataTable()?.rows()?.clear()?.draw(true);
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: localDataTablesClear<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response
    // }
    //#endregion old code

    const totalsMovementsSetAsync = async ({
        purchasesBeforeBalance = 0.00,
        purchasesPeriodBalance = 0.00,
        purchasesCurrentBalance = 0.00,
        noDefinedValue = 0.00,
        subMethod = '',
    }) => {
        const currentMethod = 'totalsMovementsSetAsync';
        let response = responseGet();
        try {
            setPurchasesBeforeBalance(purchasesBeforeBalance);
            setPurchasesPeriodBalance(purchasesPeriodBalance);
            setPurchasesCurrentBalance(purchasesCurrentBalance);
            //setNoDefinedBalance(noDefinedValue);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region initialize
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion initialize

            //#region purchases
            $(`#${dtPurchasesId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtPurchasesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            //localMovementEditDetailDeleteGetAsync(e, id, description, localDtRowIndex, 1);
                            break;
                        case 'details':
                            purchaseEditDetailDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            //localMovementEditDetailDeleteGetAsync(e, id, description, localDtRowIndex, -1);
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion purchases
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const movementsGetCallAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'movementsGetCallAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result && e.key === 'Enter') {
                $(`#${controls?.dataTables?.purchases?.buttons?.find?.id}`)?.trigger('click');
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.purchases?.icons?.find?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.buttons?.find?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.spinners?.find?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.purchases?.icons?.print?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.buttons?.print?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.spinners?.print?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.purchases?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.purchases?.icons?.find?.id}`)?.addClass(controls?.dataTables?.purchases?.icons?.find?.className);
                    $(`#${controls?.dataTables?.purchases?.buttons?.find?.id}`)?.addClass(controls?.dataTables?.purchases?.buttons?.find?.className);
                    $(`#${controls?.dataTables?.purchases?.spinners?.find?.id}`)?.addClass(controls?.dataTables?.purchases?.spinners?.find?.className);

                    $(`#${controls?.dataTables?.purchases?.icons?.print?.id}`)?.addClass(controls?.dataTables?.purchases?.icons?.print?.className);
                    $(`#${controls?.dataTables?.purchases?.buttons?.print?.id}`)?.addClass(controls?.dataTables?.purchases?.buttons?.print?.className);
                    $(`#${controls?.dataTables?.purchases?.spinners?.print?.id}`)?.addClass(controls?.dataTables?.purchases?.spinners?.print?.className);

                    $(`#${controls?.dataTables?.purchases?.icons?.back?.id}`)?.addClass(controls?.dataTables?.purchases?.icons?.back?.className);
                    $(`#${controls?.dataTables?.purchases?.buttons?.back?.id}`)?.addClass(controls?.dataTables?.purchases?.buttons?.back?.className);
                    $(`#${controls?.dataTables?.purchases?.spinners?.back?.id}`)?.addClass(controls?.dataTables?.purchases?.spinners?.back?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.find?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.purchases?.icons?.find?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.spinners?.find?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.dataTables?.purchases?.icons?.print?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.spinners?.print?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.dataTables?.purchases?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.dataTables?.purchases?.inputs?.from?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.purchases?.inputs?.to?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion controls

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.purchases?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.purchases?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.purchases?.buttons?.find?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.purchases?.buttons?.print?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.purchases?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others (methods)

    return (
        <div>
            <Menu viewName='expenses' process='suppliers' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <section className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.purchases?.[languageObj?.id]} / {globalSettings?.labels?.currentBalance?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={globalSettings?.app?.backend?.urlSuppliers}>{globalSettings?.labels?.purchases?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.currentBalance?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>
                                {/*buildings*/}
                                <BuildingHeader buildingsId={''}
                                    building={building}
                                    buildings={[]}
                                    btnSyncDisabled={''}
                                    methodGetAsync={null}
                                    processType={1}
                                    headerSectionValues={{}}
                                    showLoading={showLoading?.building}
                                    languageObj={languageObj} />

                                {/*supplier*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.supplier}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={globalSettings?.labels?.supplier?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.suppliersLogo}></img> - {globalSettings?.labels?.supplier?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button'
                                                className='btn btn-tool'
                                                data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={globalSettings?.labels?.find?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={globalSettings?.icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className='form-control bg-transparent text-black'
                                                            placeholder={globalSettings?.labels?.supplier?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.supplier?.[languageObj?.id]}
                                                            value={supplier?.description || ''} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={globalSettings?.icons?.spellCheck} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className='form-control bg-transparent text-black'
                                                            placeholder={globalSettings?.labels?.rif?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.rif?.[languageObj?.id]}
                                                            value={supplier?.rif || ''} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={globalSettings?.icons?.idCard} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className='form-control bg-transparent text-black text-right'
                                                            placeholder={globalSettings?.labels?.created?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.created?.[languageObj?.id]}
                                                            value={
                                                                dateTimeFormatGlobalSet({
                                                                    date: supplier?.date || new Date(),
                                                                    type: languageObj?.format?.date?.f1,
                                                                    format: 0,
                                                                    addTime: false,
                                                                    secondsShow: false,
                                                                    languageId: languageObj?.id,
                                                                    subMethod: currentMethod,
                                                                })?.result
                                                            } />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={globalSettings?.icons?.calendarAlt} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'>
                                    </div> */}
                                </div>{/*card*/}

                                {/*movements*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.purchases}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={globalSettings?.labels?.purchases?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.purchasesLogo}></img> -
                                            {globalSettings?.labels?.purchases?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button'
                                                className='btn btn-tool'
                                                data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={globalSettings?.labels?.find?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={globalSettings?.icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-3'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        {/* {!isUndefined(supplierPurchaseData) ? */}
                                                        <div id={purchasesFromId}
                                                            className='input-group date'
                                                            data-target-input='nearest'>
                                                            <input id={controls?.dataTables?.purchases?.inputs?.from?.id}
                                                                className={controls?.dataTables?.purchases?.inputs?.from?.className}
                                                                data-target={`#${purchasesFromId}`}
                                                                data-toggle='datetimepicker'
                                                                onFocus={() => setPurchasesFromError('')}
                                                                onKeyDown={(e) => movementsGetCallAsync({ e: e, subMethod: 'input - dateFrom', })}
                                                                placeholder={globalSettings?.labels?.from?.[languageObj?.id]}
                                                                //tabIndex={-1}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.from?.[languageObj?.id]}
                                                                type='text' />

                                                            <div className='input-group-append' data-target={`#${purchasesFromId}`} data-toggle='datetimepicker'>
                                                                <div className='input-group-text'><i className={globalSettings?.icons?.calendarAlt}></i></div>
                                                            </div>
                                                        </div>
                                                        {/* : <></>} */}
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(purchasesFromError)}</div>
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        {/* {!isUndefined(supplierPurchaseData) ? */}
                                                        <div id={purchasesToId}
                                                            className='input-group date'
                                                            data-target-input='nearest'>
                                                            <input id={controls?.dataTables?.purchases?.inputs?.to?.id}
                                                                className={controls?.dataTables?.purchases?.inputs?.to?.className}
                                                                data-target={`#${purchasesToId}`}
                                                                data-toggle='datetimepicker'
                                                                onFocus={() => setPurchasesToError('')}
                                                                onKeyDown={(e) => movementsGetCallAsync({ e: e, subMethod: 'input - dateTo', })}
                                                                placeholder={globalSettings?.labels?.to?.[languageObj?.id]}
                                                                //tabIndex={-2}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.to?.[languageObj?.id]}
                                                                type='text' />

                                                            <div className='input-group-append' data-target={`#${purchasesToId}`} data-toggle='datetimepicker'>
                                                                <div className='input-group-text'><i className={globalSettings?.icons?.calendarAlt}></i></div>
                                                            </div>
                                                        </div>
                                                        {/* : <></>} */}
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(puchasesToError)}</div>
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='row text-center text-muted'>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            {/* <div className='icheck-primary d-inline'>
                                                                <input type='radio' id={radioButtonAllId} name={radioButtonName} />
                                                                <label htmlFor={radioButtonAllId}>{globalSettings?.labels?.all?.[languageObj?.id]}</label>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            {/* <div className='icheck-primary d-inline'>
                                                                <input type='radio' id={radioButtonIncomeId} name={radioButtonName} />
                                                                <label htmlFor={radioButtonIncomeId}>{globalSettings?.labels?.income?.[languageObj?.id]}</label>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            {/* <div className='icheck-primary d-inline'>
                                                                <input type='radio' id={radioButtonExpensesId} name={radioButtonName} />
                                                                <label htmlFor={radioButtonExpensesId}>{globalSettings?.labels?.egress?.[languageObj?.id]}</label>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='form-group text-right'>
                                                    <button id={controls?.dataTables?.purchases?.buttons?.find?.id}
                                                        className={controls?.dataTables?.purchases?.buttons?.find?.className}
                                                        onClick={(e) => supplierPurchasesGetAsync({ e: e, subMethod: 'btn - purchasesSearch' })}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.search?.[languageObj?.id]}>
                                                        <i id={controls?.dataTables?.purchases?.icons?.find?.id} className={controls?.dataTables?.purchases?.icons?.find?.className} /> <span id={controls?.dataTables?.purchases?.spinners?.find?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.dataTables?.purchases?.buttons?.print?.id}
                                                        className={controls?.dataTables?.purchases?.buttons?.print?.className}
                                                        onClick={(e) => purchasesPrintAsync(e)}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.toPrint?.[languageObj?.id]} >
                                                        <i id={controls?.dataTables?.purchases?.icons?.print?.id} className={controls?.dataTables?.purchases?.icons?.print?.className} /> <span id={controls?.dataTables?.purchases?.spinners?.print?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.dataTables?.purchases?.buttons?.back?.id}
                                                        className={controls?.dataTables?.purchases?.buttons?.back?.className}
                                                        onClick={(e) => goToBackAsync({ e: e, subMethod: 'btn - goToBack', })}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.back?.[languageObj?.id]}>
                                                        <i id={controls?.dataTables?.purchases?.icons?.back?.id} className={controls?.dataTables?.purchases?.icons?.back?.className} /> <span id={controls?.dataTables?.purchases?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtPurchasesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={globalSettings?.colors?.infoColorExp}
                                                    msgText={globalSettings?.messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>
                                    </div>

                                    <div className='card-footer'>
                                        <div className='row'>
                                            <div className='col-sm-4 col-6'>
                                                <div className='description-block border-right'>
                                                    <span className={descriptionPercentageObj?.primary}>
                                                        <i className={globalSettings?.icons?.caretLeft}></i> {
                                                            //separatorsNumbersSet(numberSet(purchasesBeforeBalance, 'd').result, true).result
                                                            separatorsNumbersSet({
                                                                number: numberSet({
                                                                    number: purchasesBeforeBalance,
                                                                    type: 'd',
                                                                    languageId: languageObj?.id,
                                                                    subMethod: 'lbl - previousBalance',
                                                                })?.result,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'lbl - previousBalance',
                                                            })?.result
                                                        }
                                                    </span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{globalSettings?.labels?.previousBalance?.[languageObj?.id]}</span>
                                                </div>

                                            </div>

                                            <div className='col-sm-4 col-6'>
                                                <div className='description-block border-right'>
                                                    <span className='description-percentage text-warning'>
                                                        <i className={globalSettings?.icons?.caretUp}></i> {
                                                            //separatorsNumbersSet(numberSet(purchasesPeriodBalance, 'd').result, true).result
                                                            separatorsNumbersSet({
                                                                number: numberSet({
                                                                    number: purchasesPeriodBalance,
                                                                    type: 'd',
                                                                    languageId: languageObj?.id,
                                                                    subMethod: 'lbl - periodBalance',
                                                                })?.result,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'lbl - periodBalance',
                                                            })?.result
                                                        }
                                                    </span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{globalSettings?.labels?.periodBalance?.[languageObj?.id]}</span>
                                                </div>

                                            </div>

                                            <div className='col-sm-4 col-6'>
                                                <div className='description-block border-right'>
                                                    <span className={descriptionPercentageObj?.danger}>
                                                        <i className={globalSettings?.icons?.caretRight}></i> {
                                                            //separatorsNumbersSet(numberSet(purchasesCurrentBalance, 'd').result, true).result
                                                            separatorsNumbersSet({
                                                                number: numberSet({
                                                                    number: purchasesCurrentBalance,
                                                                    type: 'd',
                                                                    languageId: languageObj?.id,
                                                                    subMethod: 'lbl - currentBalance',
                                                                })?.result,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'lbl - currentBalance',
                                                            })?.result
                                                        }
                                                    </span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{globalSettings?.labels?.currentBalance?.[languageObj?.id]}</span>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>{/* /.content */}

            </div>
        </div>
    )
}